import React from 'react';
import { connect } from 'react-redux';
import { gql, graphql } from 'react-apollo';
import alertFirstGqlMsg from '../../alertFirstGqlMsg';
import { setAccessToken } from '../../StateHOF';

const LoginMutation = gql`
  mutation LoginMutation($loginInput: LoginInput!) {
    login(loginInput: $loginInput)
  }
`;

const loginImage = require('../../../../assets/husband.jpg');
const logo = require('../../../../assets/Wings-NoTag.svg');
const logowhite = require('../../../../assets/white-logo.png');

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      loggingIn: false,
    };
  }

  componentWillUnmount() {
    this.setState({ loggingIn: false });
  }

  render() {
    const onSubmit = async (e) => {
      e.preventDefault();

      this.setState({ loggingIn: true });

      try {
        const response = await this.props.mutate({
          variables: {
            loginInput: {
              email: this.state.email,
              password: this.state.password,
            },
          },
        });
        const token = response.data.login;
        this.props.setAccessToken(token);
      } catch (err) {
        this.setState({ loggingIn: false }, () => {
          alertFirstGqlMsg(err);
        });
      }
    };

    const { email, password, loggingIn } = this.state;

    return (
      <div className="login-section">
        <div className="login-form-section">
          <div className="login-form-container">
            <div className="curator-login-dark-logo">
              <img src={logo} alt="EncourageX logo" />
            </div>
            <h1 className="heading1-curator">
              EncourageX Curator &amp; Editor Portal
            </h1>
            <div className="curator-form-component w-form">
              <div className="form-label">Login to your account</div>
              <form
                onSubmit={onSubmit}
                id="email-form"
                name="email-form"
                data-name="Email Form"
                className="curator-form-bloc"
              >
                <label htmlFor="email" className="login-field">
                  Email
                </label>
                <input
                  type="email"
                  className="w-input"
                  name="email"
                  data-name="email"
                  id="email"
                  value={email}
                  onChange={e => this.setState({ email: e.target.value })}
                />
                <div>
                  <label htmlFor="password" className="login-field">
                    Password
                  </label>
                  <input
                    type="password"
                    className="w-input"
                    name="password"
                    data-name="password"
                    id="password"
                    value={password}
                    onChange={e => this.setState({ password: e.target.value })}
                  />
                  <a
                    href="/forget"
                    className="pw-link"
                    onClick={(e) => {
                      if (e && e.preventDefault) {
                        e.preventDefault();
                      }
                      if (!loggingIn) {
                        this.props.onSwitch('forgotPassword');
                      }
                    }}
                  >
                    Forgot Password?{' '}
                  </a>
                </div>
                <button
                  className="login-btn w-button"
                  type="submit"
                  disabled={loggingIn}
                >
                  {loggingIn ? 'Logging in...' : 'Login'}
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="login-imagery">
          <img alt="family" src={loginImage} className="login-image" />
          <div className="login-image login-gradient" />
          <div>
            <h2 className="h1-login">Build your audience with encouragement</h2>
            <h1 className="heading2-curator">
              EncourageX Curator &amp; Editor Portal
            </h1>
          </div>
          <div className="curator-login-white-logo">
            <img src={logowhite} alt="EncourageX logo" width="152" />
          </div>
        </div>
      </div>
    );
  }
}

const LoginFormWithData = graphql(LoginMutation)(Login);

const LoginFormWithState = connect(
  state => ({ accessToken: state.accessToken }),
  { setAccessToken },
)(LoginFormWithData);

export default LoginFormWithState;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/LoginLib/EmailPasswordLogin.js